import { actions } from "./action-list";

export function vehicleWiseCardCollectionFetched(value) {
  return {
    type: actions.FETCH_CARD_COLLECTION.FETCH_VEHICLE_WISE_CARD_COLLECTION,
    value,
  };
}

export function cardCollectionSummaryFetched(value) {
  return {
    type: actions.FETCH_CARD_COLLECTION.FETCH_CARD_COLLECTION_SUMMARY,
    value,
  };
}

export function dayWiseCardCollectionFetched(value) {
  return {
    type: actions.FETCH_CARD_COLLECTION.FETCH_DAY_WISE_CARD_COLLECTION,
    value,
  };
}

export function totalIssueTicketFetched(value) {
  return {
    type: actions.FETCH_CARD_COLLECTION.FETCH_ISSUE_TICKET_CARD,
    value,
  };
}

export function cardIssuedFetched(value) {
  return {
    type: actions.FETCH_CARD_COLLECTION.FETCH_CARD_ISSUED,
    value,
  };
}

export function cardRechargeFetched(value) {
  return {
    type: actions.FETCH_CARD_COLLECTION.FETCH_CARD_RECHARGED,
    value,
  };
}
